var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 73,
    viewBox: "0 0 68 73",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79052 22.5428L45.0267 0.576285C48.0232 -1.10202 51.7025 1.08621 51.7025 4.54702V47.5289C51.7025 49.8258 50.331 51.8965 48.228 52.7744L11.5326 67.8838C10.8457 68.1667 10.3967 68.8413 10.3967 69.5905C10.3967 70.3976 11.1542 70.9855 11.9265 70.7777L50.7761 60.3235C54.6485 59.2194 57.3223 55.6499 57.3223 51.5861V26.9192H62.3802C65.4837 26.9192 68 29.46 68 32.5949V72.3244C68 75.4593 65.4837 78 62.3802 78H5.61983C2.64042 77.9544 0 75.7644 0 72.6081V32.3111C0 28.2979 2.33734 24.4749 5.79052 22.5428ZM38.4201 31.3799C40.8316 29.6662 41.7525 26.7929 40.4776 24.9638C39.2027 23.1347 36.2145 23.0416 33.8035 24.7554C31.3926 26.4692 30.4711 29.3425 31.746 31.1715C33.0209 33.0006 36.0092 33.0937 38.4201 31.3799Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.cf506354.svg";
export { ForwardRef as ReactComponent };